/*
 * Back / Forward and overlays (audit 2026-10-30, found in Safari on iOS): a page that goes into the back-forward cache is restored exactly as it was left,
 * so a menu drawer, a bottom sheet or the notices panel that was open when the person followed a link was still open on Back. They are closed as the page
 * is left (pagehide) and again when it is restored from the cache (pageshow, persisted). Only what is open is touched, nothing is opened or navigated.
 */
(function () {
  'use strict';
  function closeTransient() {
    var drawer = document.querySelector('header-drawer');
    if (drawer && drawer.isOpen && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(drawer.openBtn);
    Array.prototype.forEach.call(document.querySelectorAll('nc-sheet'), function (s) { if (!s.hidden && typeof s.close === 'function') s.close(); });
    Array.prototype.forEach.call(document.querySelectorAll('nc-look-sheet'), function (s) { if (typeof s.close === 'function') s.close(); });
    Array.prototype.forEach.call(document.querySelectorAll('nc-notices-bell'), function (b) { if (typeof b.isOpen === 'function' && b.isOpen()) b.close(false); });
    document.documentElement.removeAttribute('data-nc-scroll-lock');
  }
  window.addEventListener('pagehide', closeTransient);
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeTransient(); });
  if (typeof module !== 'undefined' && module.exports) module.exports = { closeTransient: closeTransient };
})();
